import { useState } from 'react';
import {
  Content,
  Table,
  Pagination
} from 'components';
import { styles } from '../styles';
import moment from 'moment';

const SelectedTagList = ({selectedTagList}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handlePagination = (page) => {
    if (currentPage === page) return;

    setCurrentPage(page);
  };

  return (
    <>
      <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
        선택된 태그 총<span>{selectedTagList.length}</span>건
      </h4>
      <Content maxWidth={'100%'} padding={0} style={{ marginBottom: 20 }}>
        <Table
          data={selectedTagList.slice(
            (currentPage - 1) * 10,
            (currentPage - 1) * 10 + 10
          )}
          minHeight={'auto'}
          pagination={false}
          columns={[
            { title: '태그 번호', key: 'tag_id' },
            {
              title: '태그 명',
              key: 'tag_name',
              render: (item) => (
                <span style={{ ...styles.tag }}>#{item}</span>
              ),
            },
            {
              title: '등록일',
              key: 'created_at',
              render: (item) => moment.unix(item).format('YYYY-MM-DD'),
            },
            {
              title: '수정일',
              key: 'updated_at',
              render: (item) => moment.unix(item).format('YYYY-MM-DD'),
            },
            { title: '노출여부', key: 'is_show' },
            {
              title: '상품 수',
              key: 'products',
              render: (item) => {
                if (Array.isArray(item)) {
                  return `${item.length} EA`
                }
                
                return `0 EA`
              },
            },
          ]}
        />
        <Pagination 
          current={currentPage}
          pageSize={10}
          total={selectedTagList.length} 
          onChange={handlePagination}
          style={{ marginTop: 20 }} 
        />
      </Content>
    </>
  )
}

export default SelectedTagList